"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceBase = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
const exposable_object_1 = require("../helpers/exposable_object");
const api_exceptions_1 = require("../exceptions/api_exceptions");
class ServiceBase extends exposable_object_1.ExposableObject {
    constructor(service) {
        super();
        this.exposableAttributes = ["id", "name", "humanName", "data"];
        this.id = service.id;
        this.name = service.name;
        this.humanName = service.humanName;
        this.data = service.data;
    }
    getAuthTestPath() {
        try {
            // throws if missing
            this.getOperation("/test");
            return "/test";
        }
        catch (e) {
            return null;
        }
    }
    getAuthType() {
        try {
            const security = this.getSecuritySchema();
            // Our internal auth type, not covered in OpenApi
            if (security.type === "apiKey" && security.name === "accountId") {
                return "accountId";
            }
            return security.type;
        }
        catch (e) {
            return undefined;
        }
    }
    getAuthFields() {
        var _a;
        return (((_a = this.getSecuritySchema()) === null || _a === void 0 ? void 0 : _a["x-encharge-fields"]) || {});
    }
    getAuthDescription() {
        var _a;
        return ((_a = this.getSecuritySchema()) === null || _a === void 0 ? void 0 : _a.description) || "";
    }
    getOAuth2Schema() {
        var _a, _b, _c, _d;
        const schemas = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.securitySchemes;
        const schema = (schemas === null || schemas === void 0 ? void 0 : schemas.OAuth2) || (schemas === null || schemas === void 0 ? void 0 : schemas.oauth2) || this.getSecuritySchema();
        // Currently only authorizationCode flow is supported
        const flowSchema = (_d = schema === null || schema === void 0 ? void 0 : schema.flows) === null || _d === void 0 ? void 0 : _d.authorizationCode;
        if (!schema || schema.type !== "oauth2" || !flowSchema) {
            throw new api_exceptions_1.InternalException("Missing OAuth2 Schema.");
        }
        return flowSchema;
    }
    getOAuth2SchemaDescription() {
        var _a, _b, _c;
        const schemas = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.securitySchemes;
        const schema = (schemas === null || schemas === void 0 ? void 0 : schemas.OAuth2) || (schemas === null || schemas === void 0 ? void 0 : schemas.oauth2) || this.getSecuritySchema();
        return (schema === null || schema === void 0 ? void 0 : schema.description) || "";
    }
    getOperationNeedsContext(operationName) {
        var _a, _b;
        return (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"].needsContext;
    }
    getEndUserFlagsForOperation(operationName) {
        var _a, _b, _c, _d, _e, _f;
        const operation = this.getOperation(operationName);
        return {
            producesEndUsers: ((_b = (_a = operation === null || operation === void 0 ? void 0 : operation.post) === null || _a === void 0 ? void 0 : _a["x-encharge-operation"]) === null || _b === void 0 ? void 0 : _b.producesEndUsers) || false,
            consumesEndUsers: ((_d = (_c = operation === null || operation === void 0 ? void 0 : operation.post) === null || _c === void 0 ? void 0 : _c["x-encharge-operation"]) === null || _d === void 0 ? void 0 : _d.consumesEndUsers) || false,
            neededEndUserFields: (_f = (_e = operation === null || operation === void 0 ? void 0 : operation.post) === null || _e === void 0 ? void 0 : _e["x-encharge-operation"]) === null || _f === void 0 ? void 0 : _f.neededEndUserFields,
        };
    }
    getDisplayPropertiesForOperation(operationName) {
        var _a, _b;
        const operation = this.getOperation(operationName);
        return {
            name: ((_a = operation === null || operation === void 0 ? void 0 : operation.post) === null || _a === void 0 ? void 0 : _a.summary) || "",
            description: ((_b = operation === null || operation === void 0 ? void 0 : operation.post) === null || _b === void 0 ? void 0 : _b.description) || "",
        };
    }
    getTypeForOperation(operationName) {
        var _a, _b, _c;
        const type = (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.type;
        if (!type) {
            throw new api_exceptions_1.InternalException("Missing operation type");
        }
        return type;
    }
    getTriggerTypeForOperation(operationName) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.triggerType;
    }
    getTeardownForOperation(operationName) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.teardown;
    }
    getOperationInputSchema(operationName) {
        var _a, _b, _c, _d, _e;
        const result = (_e = (_d = (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b.requestBody) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d["application/json"]) === null || _e === void 0 ? void 0 : _e.schema;
        if (!result) {
            throw new api_exceptions_1.InternalException("Missing operation input schema.");
        }
        return result;
    }
    getOperationNeedsServiceFieldMappings(operationName) {
        var _a, _b, _c;
        const result = (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.needsServiceFieldMappings;
        return result;
    }
    getNeedsFullEndUsersForOperation(operationName) {
        var _a, _b, _c;
        const result = ((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.needsFullEndUsers) || false;
        return result;
    }
    getBatchFlagForOperation(operationName) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.batch;
    }
    getRunOnceFlagForOperation(operationName) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.runOnce;
    }
    getIdempotentFlagForOperation(operationName) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.idempotent;
    }
    getSkipLiquidTagReplacementFlagForOperation(operationName) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.skipLiquidTagReplacement;
    }
    getLinkConditionsForOperation(operationName) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.linkConditions) || undefined);
    }
    getSubscribeForOperation(operationName) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.subscribe) || undefined);
    }
    getUnsubscribeOperation(operationName) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.unsubscribe) || undefined);
    }
    getHelpDocsForOperation(operationName) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.helpDocs) || undefined);
    }
    getAlwaysMapOutputFields(operationName) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.alwaysMapOutputFields) || false);
    }
    getAlwaysShowInputFields(operationName) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.alwaysShowInputFields) || false);
    }
    getUpdateSourceForOperation(operationName) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.updateSource) || undefined);
    }
    getAuthFlowExtraOperation() {
        const securitySchema = this.getSecuritySchema();
        return securitySchema["x-encharge-auth-flow-extra-operation"] || undefined;
    }
    getServiceResponseSchema() {
        var _a, _b, _c, _d, _e, _f, _g;
        const responseSchema = (_g = (_f = (_e = (_d = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.responses) === null || _d === void 0 ? void 0 : _d.default) === null || _e === void 0 ? void 0 : _e.content) === null || _f === void 0 ? void 0 : _f["application/json"]) === null || _g === void 0 ? void 0 : _g.schema;
        return responseSchema || undefined;
    }
    getSecuritySchema() {
        var _a, _b, _c;
        const securitySchemes = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.securitySchemes;
        if (!securitySchemes) {
            throw new api_exceptions_1.InternalException("Missing service security schema");
        }
        // for now, we support only one security scheme per API
        const firstSecurity = securitySchemes[Object.keys(securitySchemes)[0]];
        return firstSecurity;
    }
    get syncCriteria() {
        var _a, _b, _c, _d, _e;
        return (((_e = (_d = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b["x-encharge-service"]) === null || _c === void 0 ? void 0 : _c.setup) === null || _d === void 0 ? void 0 : _d.syncCriteria) === null || _e === void 0 ? void 0 : _e.configSchema) || undefined);
    }
    get syncActivity() {
        var _a, _b, _c, _d, _e;
        return (((_e = (_d = (_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b["x-encharge-service"]) === null || _c === void 0 ? void 0 : _c.setup) === null || _d === void 0 ? void 0 : _d.syncActivity) === null || _e === void 0 ? void 0 : _e.configSchema) || undefined);
    }
    getAfterConfigOperation(configName) {
        var _a, _b, _c, _d, _e;
        return (((_e = (_d = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b["x-encharge-service"]) === null || _c === void 0 ? void 0 : _c.setup) === null || _d === void 0 ? void 0 : _d[configName]) === null || _e === void 0 ? void 0 : _e.afterConfigOperation) || undefined);
    }
    getDisconnectOperation() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b["x-encharge-service"]) === null || _c === void 0 ? void 0 : _c.disconnectOperation;
    }
    getConfigSteps() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.schema["x-encharge-service"]) === null || _b === void 0 ? void 0 : _b.setup) === null || _c === void 0 ? void 0 : _c.steps;
    }
    getOperationName(operationKey) {
        var _a, _b;
        return ((_b = (_a = this.getOperation(operationKey)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b.summary) || "";
    }
    getOperationDescription(operationKey) {
        var _a, _b;
        return ((_b = (_a = this.getOperation(operationKey)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b.description) || "";
    }
    getBaseInputFieldsForOperation(operationKey) {
        var _a, _b, _c, _d, _e;
        return (((_e = (_d = (_c = (_b = (_a = this.getOperation(operationKey)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b.requestBody) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d["application/json"]) === null || _e === void 0 ? void 0 : _e.schema) || undefined);
    }
    getBaseOutputFieldsForOperation(operationKey) {
        var _a, _b, _c, _d, _e, _f;
        return (((_f = (_e = (_d = (_c = (_b = (_a = this.getOperation(operationKey)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b.responses) === null || _c === void 0 ? void 0 : _c.default) === null || _d === void 0 ? void 0 : _d.content) === null || _e === void 0 ? void 0 : _e["application/json"]) === null || _f === void 0 ? void 0 : _f.schema) || undefined);
    }
    getIsUserInitiatedForOperation(operationKey) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationKey)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.isUserInitiated) || false);
    }
    getResultsAlreadyMappedToEndUsersForOperation(operationKey) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationKey)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.resultsAlreadyMappedToEndUsers) || false);
    }
    getLinkFromDisabledForOperation(operationKey) {
        var _a, _b, _c, _d;
        const linkFromDisabled = (_d = (_c = (_b = (_a = this.getOperation(operationKey)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.linkConditions) === null || _d === void 0 ? void 0 : _d.linkFromDisabled;
        return linkFromDisabled === undefined ? false : linkFromDisabled;
    }
    getOperation(operationName) {
        var _a, _b, _c;
        const operation = (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.schema) === null || _b === void 0 ? void 0 : _b.paths) === null || _c === void 0 ? void 0 : _c[operationName];
        if (!operation) {
            throw new api_exceptions_1.InternalException(`No operation ${operationName}`);
        }
        return operation;
    }
    getOperationURL(operationName) {
        // checks if operation exists
        this.getOperation(operationName);
        // remove trailing slash from api gateway endpoint
        const endpoint = this.data.schema.servers[0].url;
        const endpointNoTrailingSlash = endpoint.replace(/\/$/, "");
        return `${endpointNoTrailingSlash}${operationName}`;
    }
    getEventsForOperation(operationName) {
        var _a, _b, _c;
        return (((_c = (_b = (_a = this.getOperation(operationName)) === null || _a === void 0 ? void 0 : _a.post) === null || _b === void 0 ? void 0 : _b["x-encharge-operation"]) === null || _c === void 0 ? void 0 : _c.events) || undefined);
    }
}
exports.ServiceBase = ServiceBase;
//# sourceMappingURL=serviceBase.js.map